import React from "react";
import { Page } from "components/common";
import { compose } from "recompose";
import { Trans } from "react-i18next"; 

export const ConnectToXeroGuide = () => (
  <Page title="Follow up steps to connect xero" className="Terms-Conditions">
    <p>Last updated: August 20, 2024</p>

    <h4>
    <Trans>The following guidance to connect hesaab with xero govern our relationship with our clients </Trans>
     
     
      <a
        href="https://hesaab.app"
        target="_blank"
        rel="noopener noreferrer"
      >
        https://hesaab.app
      </a>{" "}
      <Trans>website </Trans>(<Trans>the "Service"</Trans>).
    </h4><br></br>
    <h5> 1. <Trans>Click on the Highlighted Section</Trans></h5>
        <div className="justify-content-center align-items-center d-flex flex-column">
            <div>
                <p>
                    <br></br>
                    <Trans>
                        Begin by logging in to your account as a subscriber. Once logged in, navigate to 
                        the highlighted section. Clicking on this section will display a list of available 
                        organizations, along with a "Manage All" button for easy access.
                    </Trans>

                </p>
            </div>
            <div>
                <img src="/images/step 1 to open the orgs list.png" alt="Encircled Section" />
            </div>
        </div>

    <h5>2. <Trans>Manage All Organizations or Add a New One</Trans></h5>
    <div className="justify-content-center align-items-center d-flex flex-column">
            <div>
                <p>
                    <br></br>
                    <Trans>
                    If organizations are available, a list will pop up. If no organizations are listed, 
                    click the "+" button to create a new organization. If you already have existing 
                    organizations, you can click the "Manage All" button, which will take you to the 
                    organization management page.
                    </Trans>
                </p>
            </div>
        <div>
        <   img src="/images/step 2 to click on manage all.png" alt="Encircled Section" />
        </div>
    </div>
    <h5> 3. <Trans>Click the Edit Icon to Connect an Existing Organization or Add a New One</Trans></h5>
    <div className="justify-content-center align-items-center d-flex flex-column">
        <div>
            <p>
            <br></br>
                <Trans>If no organizations are created or listed, you can click on the "+ Add New Organization" 
                button to create one. After this process, you will have the option to connect with Xero.</Trans>
            </p>
        </div>
        <div>
        <img src="/images/step 3-1  xero guide.png" alt="Encircled Section" />
        </div>
    </div>
    <div>
        <Trans>or</Trans>
    </div>
    <div>
        <Trans>
            If you have one or more organizations already created, you can choose which one you want to connect 
            with Xero. Simply click on the edit icon (pencil icon) next to the desired organization, and you will 
            be taken to the edit organization page where you will start connecting the hesaab with xero.
        </Trans>
    </div>
    <div className="justify-content-center align-items-center d-flex flex-column">
    <div>
        <img src="/images/step 3-2  xero guide.png" alt="Encircled Section" />
    </div>
    </div>

    <div className="mt-5">
        <h5>4. <Trans>Click on "Connect to Xero"</Trans></h5>
        <div className="justify-content-center align-items-center d-flex flex-column">
            <div>
                <p>
                <br></br>
                    <Trans>
                    Now that you're on the edit organization page after clicking the Edit button in the previous 
                    step, you need to click the "Connect to Xero" button shown in the image below to begin the 
                    connection process. After clicking this button, you'll be redirected to Xero. If you're 
                    already logged in, the connection process will proceed; otherwise, you'll be prompted to 
                    enter your login credentials.
                    </Trans>
                </p>
            </div>
            <div>
                <img src="/images/step 4 xero guide.png" alt="Encircled Section" />
            </div>
        </div>
    </div>

    <div className="mt-5">
        <h5>5. <Trans>Select any organisation from dropdown</Trans></h5>
        <div className="justify-content-center align-items-center d-flex flex-column">
            <div className="text-start">
                <br></br>
                <p>
                    <Trans>If you're already logged in, you'll be prompted to select an organization from the 
                    dropdown menu, as shown in the image below. Once you select an organization, you'll also 
                    see a summary of what you can access on Hesaab using that organization.</Trans>
                </p>
            </div>
            <div>
                <img src="/images/step 5 to select the orgs from xero.png" alt="Encircled Section" />
            </div>
        </div>
    </div>

    <div className="mt-5">
        <h5>6. <Trans>Click "Allow Access" to Complete the Xero Connection</Trans></h5>
        <div className="justify-content-center align-items-center d-flex flex-column">
            <div>
                <br></br>
                <p>
                    <Trans>After selecting an available organization as shown in the image above, click the 
                    "Allow Access" button. Before granting access, please review all permissions provided 
                    by Xero for the selected organization to ensure they meet your requirements.</Trans>
                </p>
            </div>
            <div>
                <img src="/images/step 6 to allow access on xero.png" alt="Encircled Section" />
            </div>
        </div>   
    </div>

    <div className="mt-5">
        <h5>7. <Trans>Confirmation: Connection to Xero Successful</Trans></h5>
        <div className="justify-content-center align-items-center d-flex flex-column">
            <div>
                <p>
                    <Trans>After clicking the "Allow Access" button, Hesaab will connect to Xero for the selected 
                    organization. You will be automatically redirected to the organization page where you 
                    previously clicked "Connect to Xero." This time, the page will display "Connected to 
                    [Your Organization Name]."</Trans>
                </p>
            </div>
            <div>
                <img src="/images/step 7 after allowing access.png" alt="Encircled Section" />
            </div>
        </div>
    </div>

    <div className="mt-5">
      <h5><Trans>Thank you for taking the time to understand on how to connect hesaab with xero.</Trans>
</h5>
    </div>
  </Page>
);

const enhance = compose();

export default enhance(ConnectToXeroGuide);